import { Form, notification, Radio, Select, Space } from "antd";
import React, { useEffect, useState } from "react";
import API_SERVICE from "shared/services/api-service";
import FormInput from "components/FormInput/FormInput";
import "./Aggregator.scss"
import { useDispatch, useSelector } from "react-redux";
import { setScreenHeader } from "shared/redux/common-reducer";
import { RootState } from "shared/redux/store";
import OIButton from "shared/ComponentsOI/OIButton/OIButton";
import { useHistory, useLocation } from "react-router-dom";
import { getUser } from "shared/services/Utility";
const { Option } = Select;
type Props = {}


const AddAggregator: React.FC<Props> = () => {

    const location = useLocation() as any;
    const history = useHistory();
    const dispatch = useDispatch();
    const [addAggregatorForm] = Form.useForm();
    const [productsList, setProductsList] = useState([]) as any;
    const [aggregatorList, setAggregatorList] = useState([]) as any;
    const [aggregatorPropertiesList, setAggregatorPropertiesList] = useState([]) as any;
    const [aggregatorId, setAggregatorId] = useState("")
    const { editAggregatorData, screenType } = location?.state;
    const [selectedRoute, setSelectedRoute] = useState("API");
    const [loading, setLoading] = useState(false)
    const { appColors }: any = useSelector((state: RootState) => state.common);
    const customStylesRadio: any = { "--bgColor": appColors?.appSecondaryColor ?? "", };
    const btnStylePrimary: any = { "--custColor": appColors?.appPrimaryColor };
    const btnStyleSecondary: any = { "--custColor": appColors?.appSecondaryColor };

    useEffect(() => {
        dispatch(setScreenHeader({
            backScreenTitle: "Aggregator Configuration",
            backScreenPath: "/aggregator-config",
            screenTitle: screenType === "edit" ? "Edit Aggregator" : "Add Aggregator",
        }))
        getLoanProducts();
        if (screenType === "edit") {
            addAggregatorForm.setFieldsValue({
                product: editAggregatorData?.loanProductName,
                aggregator: editAggregatorData?.name
            })
            setAggregatorPropertiesList(editAggregatorData?.properties)
        }

    }, []);

    const getLoanProducts = () => {
        API_SERVICE.getLoanProductList(getUser()?.businessId).then(({ data }) => {
            if (data) {
                let product = data.payload.filter((item) => item.active);
                setProductsList(product);
            }

        });
    };

    const getAggregatorsByProductId = (loanProductId) => {
        API_SERVICE.getAggregatorsByProductId(loanProductId).then(({ data }) => {
            if (data) {
                setAggregatorList(data?.payload);
            }
        });
    };

    const onFinish = () => {
        let payload
        if (screenType === "add") {
            payload = {
                aggregatorId: aggregatorId,
                routingMode: selectedRoute,
                properties: aggregatorPropertiesList
            }
            setLoading(true);
            API_SERVICE.addAggregator(payload)
                .then(({ data }) => {
                    notification.success({ message: data?.payload })
                    history.push("/aggregator-config")
                })
                .catch((e: any) =>{
                    notification.error({message:e?.response?.data?.payload?.errorMessage})
                    API_SERVICE.handleErrors(e)
                }                   
                )
                .finally(() => {
                    setLoading(false);
                }
                );
        }
        else {
            payload = {
                id: editAggregatorData?.id,
                properties: aggregatorPropertiesList
            }
            setLoading(true);
            API_SERVICE.updateAggregator(payload)
                .then(({ data }) => {
                    notification.success({ message: data?.payload })
                    history.push("/aggregator-config")
                })
                .catch((e: any) =>
                    API_SERVICE.handleErrors(e)
                )
                .finally(() => {
                    setLoading(false);
                }
                );
        }
    }

    const handleSelectAggregator = (value: string) => {
        setAggregatorId(value)
        let tmpList = aggregatorList?.find(item => item.id === value)?.properties ?? []
        setAggregatorPropertiesList(tmpList)
    }

    const handleAPIProperty = (index, property) => {
        let tmpAPIProperty = ((prev) => {
            const updated = [...prev];
            updated[index].value = property;
            return updated;
        });
        setAggregatorPropertiesList(tmpAPIProperty)
    }

    return (
        <>
            <div className="content-box"
                style={{
                    marginTop: "20px",
                    marginLeft: "10px",
                }}>

                <Form
                    form={addAggregatorForm}
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <div className="aggregator-select" style={{ width: "450px", marginLeft: "20px", border: "none" }}>
                        <Form.Item
                            label="Product"
                            rules={[{ required: true, message: "Please select product" }]}
                            name="product"
                        >
                            <Select
                                showSearch
                                placeholder="Select Product"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option!.children as unknown as string)
                                        ?.toLowerCase()
                                        ?.includes(input?.toLowerCase())
                                }
                                style={{ border: "none" }}
                                onChange={(value) => getAggregatorsByProductId(value)}
                                disabled={screenType === "edit"}
                            >
                                {productsList?.map((item: any, i: number) => (
                                    <Option key={i} value={item.loanProductId}>
                                        {item.loanProduct}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </div>
                    <div className="aggregator-select" style={{ width: "450px", marginLeft: "20px", border: "none" }}>
                        <Form.Item
                            label="Aggregator Name"
                            rules={[{ required: true, message: "Please select aggregator" }]}
                            name="aggregator"
                        >
                            <Select
                                showSearch
                                placeholder="Select Aggregator"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option!.children as unknown as string)
                                        ?.toLowerCase()
                                        ?.includes(input?.toLowerCase())
                                }
                                style={{ border: "none" }}
                                onChange={(value) => handleSelectAggregator(value)}
                                disabled={screenType === "edit"}
                            >
                                {aggregatorList?.map((item: any, i: number) => (
                                    <Option key={i} value={item?.id}>
                                        {item.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </div>
                    <div style={{ width: "450px", marginLeft: '20px', marginTop: "20px" }}>
                        <div className="preview-name-div">
                            <label >Select Route</label>
                        </div>
                        <Radio.Group
                            onChange={(e) => setSelectedRoute(e.target.value)}
                            defaultValue="API"
                            value={selectedRoute}
                            className="aggregator-radio"
                            style={customStylesRadio}
                            disabled={screenType === "edit"}
                        >
                            <Radio value="API">API</Radio>
                        </Radio.Group>
                    </div>
                    {aggregatorPropertiesList?.map((item, index) => (
                        <div className="agggregator-input" style={{ width: "350px", marginLeft: "20px", marginTop: "20px", background: "none" }}>
                            <FormInput
                                name={`apiProperty${index}`}
                                label={item?.name} 
                                colon={false}
                                onChange={(e) => handleAPIProperty(index, e?.target?.value)}
                                defaultValue={item?.value}
                                rules={[
                                    {
                                        required:true,
                                        message:"Please enter " + item?.name
                                    }
                                ]}
                            />
                        </div>
                    ))}
                    <div style={{ marginLeft: "50px", marginTop: "20px", marginBottom: "10px" }}>
                        <Space>
                            <OIButton
                                label="Save"
                                style={btnStylePrimary}
                                type="primary"
                                htmlType="submit"
                            />
                            <div style={{ marginLeft: "10px" }}>
                                <OIButton
                                    label="Cancel"
                                    style={btnStyleSecondary}
                                    onClick={() => {
                                        history.push("/aggregator-config")
                                    }
                                    }
                                />
                            </div>
                        </Space>
                    </div>
                </Form>

            </div>
        </>
    )
}

export default AddAggregator;